// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1rCJV","ranges":"BmiRanges_ranges__2hcn9"};